import axios from "axios";
import config from "../config";

axios.defaults.baseURL = config.api.baseURL;

const http = axios;

export default http;
